/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcCore from "@grapecity/wijmo"

import { useEffect, useState } from "react"
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap"
import LocalAlertComponent from "../../../../components/LocalAlertComponent"
import ComboBox from "../../../../components/ComboBox"
import { T表紙分割 } from "../../../../components/ComboBox/HyosiBunkatuComboBox"
import { T請求内訳 } from "../../../../components/ComboBox/SeikyuUtiwakeComboBox"
import { T部所マスタ } from "../../../../components/ComboBox/BusyoComboBox"
import TextInput from "../../../../components/InputWrapper/TextInput"
import {
  ModalOuter,
  TModalTypes,
} from "../../../../components/Modal/ModalOuter"
import Spinner from "../../../../components/Spinner"
import NinusiService from "../../../../service/master/ninusi/ninusiService"
import NinusiSeikyuService from "../../../../service/master/ninusiseikyu/ninusiSeikyuService"
import KaikonZyutyuHaisyaPatternService from "../../../../service/orderContainer/kaikonZyutyuHaisyaPattern/kaikonZyutyuHaisyaPatternService"
import {
  TKaikonZyutyuHaisyaPatternListGetReq,
  TKaikonZyutyuHaisyaPatternListGetRes,
} from "../../../../service/orderContainer/kaikonZyutyuHaisyaPattern/TKaikonZyutyuHaisyaPattern"
import { TWijmoComboBox } from "../../../../type/wijmoComponents"
import { KaikonZyutyuHaisyaPatternModalProvider } from "./KaikonZyutyuHaisyaPatternModalContext"
import KaikonZyutyuHaisyaListGrid from "./KaikonZyutyuHaisyaPatternModalGrid"
import BusyoService from "../../../../service/master/busyo/busyoService"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { setAlerts } from "../../../../globalStore/alertStore"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../../.."

/**
 * 海コン受注配車パターン入力用モーダル
 * @return {*}
 */
const KaikonZyutyuHaisyaPatternModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    ninusiCode?: string
    ninusiName?: string
    zyutyubusyo?: T部所マスタ
    zyutyubusyoCode?: string
    setPattern: (value: TKaikonZyutyuHaisyaPatternListGetRes) => unknown
  }
> = (props) => {
  let gridId = "KaikonZyutyuHaisyaPtnMdl_GridId"

  //#region [state]
  const dispatch: AppDispatch = useDispatch()
  // 画面共通
  const [isSearching, setIsSearching] = useState(false)

  const [searchResult, setSearchResult] =
    useState<TKaikonZyutyuHaisyaPatternListGetRes[]>()

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //１列目

  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主略称1, set荷主略称1] = useState<string>()

  const [荷主請求ID, set荷主請求ID] = useState<number | null>()
  const [表紙分割ItemSource, set表紙分割ItemSource] = useState<T表紙分割[]>()

  const [荷主請求内訳ID, set荷主請求内訳ID] = useState<number | null>()
  const [請求内訳ItemSource, set請求内訳ItemSource] = useState<T請求内訳[]>()

  //２列目
  const [受注部所コード, set受注部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [受注配車パターンコード, set受注配車パターンコード] = useState<string>()

  const [地名, set地名] = useState<string>()
  const [社名, set社名] = useState<string>()
  //#endregion

  //#region [comboboxState]

  // 表紙分割
  const [表紙分割ComboBox, set表紙分割ComboBox] = useState<TWijmoComboBox<
    T表紙分割["荷主請求ID"],
    T表紙分割
  > | null>(null)
  const [表紙分割IsLoadEnded, set表紙分割IsLoadEnded] = useState<boolean>(false)
  // 請求内訳
  const [請求内訳ComboBox, set請求内訳ComboBox] = useState<TWijmoComboBox<
    T請求内訳["荷主請求内訳ID"],
    T請求内訳
  > | null>(null)
  const [請求内訳IsLoadEnded, set請求内訳IsLoadEnded] = useState<boolean>(false)
  // 受注部所
  const [受注部所ComboBox, set受注部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [受注部所isLoadEnded, set受注部所isLoadEnded] = useState<boolean>(false)
  //#region grid操作
  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  //#endregion

  //#endregion

  //#region [effect]
  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      set受注部所コード(props.zyutyubusyo?.部所コード ?? "")
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (!gridInitialized) return
    //初回filter作成時にqueryがいた場合、検索を行う
    if (props.isShow) {
      setAlertSource(undefined)
      set荷主コード(props.ninusiCode)
      set荷主略称1(props.ninusiName)
      set受注部所コード(props.zyutyubusyo?.部所コード ?? "")
      if (
        !wjcCore.isNullOrWhiteSpace(props.ninusiCode ?? "") ||
        !wjcCore.isNullOrWhiteSpace(props.ninusiName ?? "")
      ) {
        search({
          荷主コード: props.ninusiCode ?? "",
          受注部所コード: props.zyutyubusyo?.部所コード ?? "",
        })
      }
    } else {
      // 非表示時中身を空にして閉じる
      set荷主コード("")
      set荷主略称1("")
      set荷主請求ID(null)
      set表紙分割ItemSource([])
      set荷主請求内訳ID(null)
      set請求内訳ItemSource([])
      set受注配車パターンコード("")
      setSearchResult([])
    }
  }, [props.isShow, gridInitialized])

  //#endregion

  //#region [method]

  /**
   * 検索
   */
  const search = async (
    searchCondition?: TKaikonZyutyuHaisyaPatternListGetReq
  ) => {
    setIsSearching(true)
    setAlertSource(undefined)

    let currentSearchCondition: TKaikonZyutyuHaisyaPatternListGetReq | undefined
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }

    // TODO:検索処理導入
    try {
      const service = new KaikonZyutyuHaisyaPatternService()

      const res = await service.getList(currentSearchCondition)
      setSearchResult(res.data)
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSearching(false)
    }
  }

  /**
   * 検索条件作成
   * @param queryString
   */
  const createSearchCondition = (): TKaikonZyutyuHaisyaPatternListGetReq => ({
    荷主コード: 荷主コード ?? "",
    荷主略称1: 荷主略称1,
    受注配車パターンコード,
    地名,
    社名,
    受注部所コード: 受注部所コード ?? "",
    荷主請求ID: 荷主請求ID ?? undefined,
    荷主請求内訳ID: 荷主請求内訳ID ?? undefined,
  })

  /**
   *
   * @param 荷主コード
   * @returns
   */
  const set表紙 = async (荷主コード: string) => {
    try {
      if (荷主コード == null || 荷主コード === "") {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
        return
      }
      const 荷主res = await new NinusiService().getList({
        荷主コード: 荷主コード !== "" ? 荷主コード : undefined,
        完全一致フラグ: true,
      })
      if (荷主res.data == null || 荷主res.data.length <= 0) {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
        return
      }
      const 荷主 = 荷主res.data[0]
      set荷主コード(荷主.荷主コード)
      set荷主略称1(荷主.荷主略称1)
      if (荷主 != null) {
        const ninusiSeikyuService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiSeikyuService.getList({
          荷主Id: 荷主.荷主ID,
        })
        if (荷主請求res && 荷主請求res.data.length > 0) {
          set表紙分割ItemSource([...荷主請求res.data])
          set請求内訳ItemSource([])
        } else {
          set表紙分割ItemSource([])
          set請求内訳ItemSource([])
        }
      } else {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }
  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={"海コン受注配車パターン検索"}
      setIsShow={props.setIsShow}
      dialogClassName="mw-80"
      footer={props.footer}>
      <Spinner inModal searching={isSearching}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件 */}
            <Form>
              <Container fluid className="contents-search-main">
                <Row>
                  <Col>
                    <div className="search-condition-table">
                      <div className="search-condition-row">
                        {props.zyutyubusyo != null &&
                        !wjcCore.isNullOrWhiteSpace(
                          props.zyutyubusyo.部所コード
                        ) ? (
                          <Table className="form-table">
                            <tbody>
                              <tr>
                                <th className="min-w-8rem">部所</th>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                    width: "20rem",
                                  }}>
                                  <span>
                                    {props.zyutyubusyo.部所コード} :{" "}
                                    {props.zyutyubusyo.部所名}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        ) : (
                          <ComboBox.Busyo
                            placeholder="受注部所"
                            isLoadEnded={受注部所isLoadEnded}
                            setIsLoadEnded={set受注部所isLoadEnded}
                            isAllSelect={false}
                            isRequired={true}
                            itemsSource={部所ItemSource}
                            selectedValue={受注部所コード}
                            listFilter={(d) => d.運行部所フラグ === 1}
                            setSelectedValue={(v) => {
                              set受注部所コード(v)
                            }}
                            ComboBox={受注部所ComboBox}
                            setComboBox={set受注部所ComboBox}></ComboBox.Busyo>
                        )}
                      </div>
                      <div className="search-condition-row">
                        <div className="input-group">
                          <TextInput
                            style={{ width: "6rem" }}
                            id="荷主コード"
                            autoFocus={true}
                            name="荷主コード"
                            value={荷主コード}
                            setValue={async (v) => {
                              set荷主コード(v)
                            }}
                            onBlur={async (e) => {
                              const v = e.currentTarget.value
                              set表紙(v)
                            }}
                            maxLength={5}
                            placeholder="荷主CD"
                          />
                          <TextInput
                            style={{ width: "25rem" }}
                            id="荷主名"
                            name="荷主名"
                            value={荷主略称1}
                            setValue={set荷主略称1}
                            maxLength={100}
                            placeholder="荷主略称"
                          />
                          <ComboBox.HyosiBunkatu
                            placeholder="表紙名"
                            isReadOnly={
                              表紙分割ItemSource == null ||
                              表紙分割ItemSource.length <= 0
                                ? true
                                : false
                            }
                            itemsSource={表紙分割ItemSource}
                            isLoadEnded={表紙分割IsLoadEnded}
                            setIsLoadEnded={set表紙分割IsLoadEnded}
                            setSelectedValue={(v) => {
                              set荷主請求ID(v)
                            }}
                            selectedValue={荷主請求ID}
                            ComboBox={表紙分割ComboBox}
                            setComboBox={
                              set表紙分割ComboBox
                            }></ComboBox.HyosiBunkatu>
                          <div className="w-12rem">
                            <ComboBox.SeikyuUtiwake
                              placeholder="請求内訳"
                              isReadOnly={
                                請求内訳ItemSource == null ||
                                請求内訳ItemSource.length <= 0
                                  ? true
                                  : false
                              }
                              itemsSource={請求内訳ItemSource}
                              isLoadEnded={請求内訳IsLoadEnded}
                              setIsLoadEnded={set請求内訳IsLoadEnded}
                              setSelectedValue={(v) => {
                                set荷主請求内訳ID(v)
                              }}
                              selectedValue={荷主請求内訳ID}
                              ComboBox={請求内訳ComboBox}
                              setComboBox={
                                set請求内訳ComboBox
                              }></ComboBox.SeikyuUtiwake>
                          </div>
                        </div>
                        <div className="w-12rem">
                          <TextInput
                            id="受注配車パターンコード"
                            name="受注配車パターンコード"
                            value={受注配車パターンコード}
                            setValue={set受注配車パターンコード}
                            maxLength={100}
                            placeholder="パターンコード"
                          />
                        </div>
                        <div className="w-10rem">
                          <TextInput
                            id="作業場所社名"
                            name="作業場所社名"
                            value={社名}
                            setValue={set社名}
                            maxLength={100}
                            placeholder="社名・ヤード"
                          />
                        </div>
                        <div className="w-10rem">
                          <TextInput
                            id="作業場所地名"
                            name="作業場所地名"
                            value={地名}
                            setValue={set地名}
                            maxLength={100}
                            placeholder="地名"
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className="text-end">
                    <Button
                      type="submit"
                      disabled={isSearching}
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        search()
                      }}>
                      <FontAwesomeIcon icon={faSearch} />
                      検索
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="mt-2">
              <KaikonZyutyuHaisyaPatternModalProvider
                isSearching={{ state: isSearching, setState: setIsSearching }}
                isRestoreSearching={{
                  state: isRestoreSearching,
                  setState: setIsRestoreSearching,
                }}
                SearchResult={searchResult}
                gridInitialized={{
                  state: gridInitialized,
                  setState: setGridInitialized,
                }}>
                <KaikonZyutyuHaisyaListGrid
                  setPattern={(v) => {
                    props.setPattern(v)
                    props.setIsShow(false)
                  }}
                  gridId={gridId}></KaikonZyutyuHaisyaListGrid>
              </KaikonZyutyuHaisyaPatternModalProvider>
            </div>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default KaikonZyutyuHaisyaPatternModal
